type Haptic = {
  impactOccurred?: (style: "light" | "medium" | "heavy" | "rigid" | "soft") => void;
  notificationOccurred?: (type: "error" | "success" | "warning") => void;
};

type TelegramBackButton = {
  show?: () => void;
  hide?: () => void;
  onClick?: (callback: () => void) => void;
  offClick?: (callback: () => void) => void;
};

type TelegramThemeParams = {
  bg_color?: string;
  secondary_bg_color?: string;
  text_color?: string;
  hint_color?: string;
  button_color?: string;
  button_text_color?: string;
};

type TelegramWebApp = {
  initData?: string;
  colorScheme?: "light" | "dark";
  themeParams?: TelegramThemeParams;
  ready?: () => void;
  expand?: () => void;
  disableVerticalSwipes?: () => void;
  setHeaderColor?: (color: string) => void;
  setBackgroundColor?: (color: string) => void;
  HapticFeedback?: Haptic;
  BackButton?: TelegramBackButton;
};

declare global {
  interface Window { Telegram?: { WebApp?: TelegramWebApp } }
}

let activeBackHandler: (() => void) | null = null;

function app(): TelegramWebApp | undefined { return window.Telegram?.WebApp; }

function applyTheme(tg: TelegramWebApp): void {
  const root = document.documentElement;
  const params = tg.themeParams;
  if (!params) return;

  if (params.text_color) root.style.setProperty("--tg-text", params.text_color);
  if (params.hint_color) root.style.setProperty("--tg-hint", params.hint_color);
  if (params.button_color) root.style.setProperty("--tg-button", params.button_color);
  if (params.button_text_color) root.style.setProperty("--tg-button-text", params.button_text_color);
}

export function initTelegram(): void {
  const tg = app();
  if (!tg) return;
  tg.ready?.();
  tg.expand?.();
  tg.disableVerticalSwipes?.();
  tg.setHeaderColor?.("#080a10");
  tg.setBackgroundColor?.("#080a10");
  applyTheme(tg);
}

export function setTelegramBackHandler(handler: (() => void) | null): void {
  const back = app()?.BackButton;
  if (!back) return;

  if (activeBackHandler) back.offClick?.(activeBackHandler);
  activeBackHandler = handler;

  if (handler) {
    back.onClick?.(handler);
    back.show?.();
  } else {
    back.hide?.();
  }
}

export function telegramInitData(): string { return app()?.initData || ""; }
export function impact(style: "light" | "medium" | "heavy" | "rigid" | "soft"): void { app()?.HapticFeedback?.impactOccurred?.(style); }
export function successHaptic(): void { app()?.HapticFeedback?.notificationOccurred?.("success"); }
